import React from 'react'

function PatientOverview() {
  return (
    <>
    <table className="table table-striped gy-5 gs-5">
                      
                      <tbody>
                      <tr>
                          <td>First Name :</td>
                          <td>Patient First Name</td>
                      </tr>
                      <tr>
                          <td>Last Name :</td>
                          <td>Patient Last Name</td>
                      </tr>
                      <tr>
                          <td>Doctor :</td>
                          <td>Doctor Name</td>
                      </tr>
                      <tr>
                          <td>Birthdate :</td>
                          <td>Date of Birth</td>
                      </tr>
                      <tr>
                          <td>Welcome Sent</td>
                          <td>Yes</td>
                      </tr>
                      <tr>
                          <td>Welcome Sent On</td>
                          <td>2024-03-15</td>
                      </tr>
                      <tr>
                          <td>Created</td>
                          <td>Date</td>
                      </tr>
                      <tr>
                          <td>
                              Modified
                          </td>
                          <td>Modified</td>
                      </tr>
                      </tbody>
                  </table>
    </>
  )
}

export default PatientOverview